import { useState, useCallback } from 'react'
import { authFetch } from '../utils/authFetch'
import { DataQualityReport, SegmentProcessResult } from '../types'

interface UseDataQualityReturn {
  report: DataQualityReport | null
  isLoading: boolean
  error: string | null
  analyzeQuality: (segmentResult: SegmentProcessResult, startDate: string, endDate: string) => Promise<void>
  clearReport: () => void
}

export function useDataQuality(): UseDataQualityReturn {
  const [report, setReport] = useState<DataQualityReport | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const analyzeQuality = useCallback(async (
    segmentResult: SegmentProcessResult,
    startDate: string,
    endDate: string
  ) => {
    setIsLoading(true)
    setError(null)
    try {
      const startMs = new Date(startDate + 'T00:00:00').getTime()
      const endMs = new Date(endDate + 'T00:00:00').getTime()
      const totalPeriodDays = Math.round((endMs - startMs) / (24 * 60 * 60 * 1000))

      const response = await authFetch('/api/analysis/data-quality', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          companies: segmentResult.companies,
          totalPeriodDays,
          startDate,
          endDate,
        }),
      })

      if (!response.ok) {
        const data = await response.json().catch(() => ({}))
        throw new Error(data.error || `HTTP ${response.status}`)
      }

      const data: DataQualityReport = await response.json()
      setReport(data)
    } catch (err: any) {
      setError(err.message || 'Erro ao analisar qualidade dos dados')
    } finally {
      setIsLoading(false)
    }
  }, [])

  const clearReport = useCallback(() => {
    setReport(null)
    setError(null)
  }, [])

  return { report, isLoading, error, analyzeQuality, clearReport }
}
